import { render, staticRenderFns } from "./link-shop.vue?vue&type=template&id=d8ea2048&scoped=true&"
import script from "./link-shop.vue?vue&type=script&lang=js&"
export * from "./link-shop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ea2048",
  null
  
)

export default component.exports